<template>
  <div class="labeled-select">
    <label v-if="label || $slots.label" :for="id" class="labeled-select__label">
      <slot name="label">{{ label }}</slot>
      <span v-if="required" class="labeled-select__required" aria-hidden="true">*</span>
    </label>

    <v-select v-model="value" :input-id="id" :label="optionLabel" v-bind="$attrs">
      <!-- Forward every other slot (option, selected-option, no-options, etc.) -->
      <template
        v-for="(_, name) in slots"
        :key="name"
        #[name]="slotProps"
      >
        <slot v-if="name !== 'label'" :name="name" v-bind="slotProps || {}" />
      </template>
    </v-select>
  </div>
</template>

<script setup lang="ts">
import { computed, useSlots } from 'vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

// Let $attrs go to <v-select>, not to the wrapper <div>
defineOptions({ inheritAttrs: false })

const props = defineProps({
  modelValue: { type: [String, Number, Object, Array, Boolean], default: null },
  label: { type: String, default: '' },
  // vue-select's own `label` prop (which option key to display) is renamed here
  optionLabel: { type: String, default: 'label' },
  // Optional: pass your own id; otherwise one is generated
  id: { type: String, default: () => `labeled-select-${Math.random().toString(36).slice(2, 9)}` },
  required: { type: Boolean, default: false },
})

const emit = defineEmits(['update:modelValue'])

const value = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v),
})

const slots = useSlots();

</script>

<style scoped lang="scss">

.labeled-select {
  display: flex;
  flex-direction: column;
  gap: 6px
}

.labeled-select__label {
  font-size: 12px;
  color: var(--label-color);
}

// .labeled-select__required {
//   color: #c62828;
//   margin-left: 0.125rem;
// }
</style>